import React from "react";
import styled from "styled-components";

export default styled.div`
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 570px;
    // min-height: 394px;
    text-align: center;
    padding: 10px 32px;
    box-sizing: border-box;
    // border-radius: 5px;
    display: none;
    z-index: 20;
    box-shadow: 5px 5px 25px #00000054;
    
    .rdtOpen .rdtPicker {
        top: -170%;
        left: 50%;
        transform: translate(-50%);
        border: 1px solid gray;
    }
    
    .rte {
        min-height: 300px;
        width: 93%;
        margin: 0 auto;
    }

    /* Long notes: scroll within the note text instead of growing unbounded and
       pushing the Save button off-screen. Applies to both the editable note and
       the read-only (view) note, which share the .rte editor. */
    .rte .public-DraftEditor-content {
        max-height: 50vh;
        overflow-y: auto;
    }

    /* Keep the note modals within the viewport so the Save button is always
       reachable by scrolling. Scoped to the note modals by id so date-picker
       popups in other modals that share this component aren't clipped. */
    &#note-modal,
    &#note-edit-modal {
        max-height: 95vh;
        overflow-y: auto;
    }

    .rte span {
        font-weight: unset;
    }

    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
`;